import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from './../authentication/authentication.service';
import { LoggingService } from './../logging/logging.service';
import {
	FlashProduct,
	FlashProductGroup,
	EditFlashProductModel,
	EditFlashProductGroupModel
} from '../../models/inModels/Flash';
import { LazyLoadEvent } from '../../models/DataTables/lazyLoadEvent';


@Injectable()
export class FlashService {
	private flashProductUrl = '/api/flash/products';
	private flashProductGroupUrl = '/api/flash/groups';
	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService
	) { }

	search(event: LazyLoadEvent): Promise<any> {
		if (event.sortField == "Min") event.sortField = "Minimum";
		if (event.sortField == "Max") event.sortField = "Maximum";
		// Convert filters
		for (const key in event.filters) {
			if (event.filters.hasOwnProperty(key)) {
				if (key.toLowerCase() === "min") {
					event.filters["Minimum"] = event.filters[key];
					delete event.filters[key];
				} else if (key.toLowerCase() === "max") {
					event.filters["Maximum"] = event.filters[key];
					delete event.filters[key];
				}
			}
		}

		return this.http.post(`${this.auth.apiUrl}${this.flashProductUrl}/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<FlashProduct> {
		return this.http.get(`${this.auth.apiUrl}${this.flashProductUrl}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as FlashProduct)
			.catch(error => this.logging.handleError(error));
	}

	create(user: EditFlashProductModel): Promise<FlashProduct> {
		return this.http.post(`${this.auth.apiUrl}${this.flashProductUrl}/create`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as FlashProduct)
			.catch(error => this.logging.handleError(error));
	}

	delete(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.flashProductUrl}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	update(user: EditFlashProductModel): Promise<FlashProduct> {
		return this.http.post(`${this.auth.apiUrl}${this.flashProductUrl}/update`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as FlashProduct)
			.catch(error => this.logging.handleError(error));
	}

	searchGroup(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.flashProductGroupUrl}/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getGroup(id: number): Promise<FlashProductGroup> {
		return this.http.get(`${this.auth.apiUrl}${this.flashProductGroupUrl}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as FlashProductGroup)
			.catch(error => this.logging.handleError(error));
	}

	createGroup(user: EditFlashProductGroupModel): Promise<FlashProductGroup> {
		return this.http.post(`${this.auth.apiUrl}${this.flashProductGroupUrl}/create`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as FlashProductGroup)
			.catch(error => this.logging.handleError(error));
	}

	deleteGroup(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.flashProductGroupUrl}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	updateGroup(user: EditFlashProductGroupModel): Promise<FlashProductGroup> {
		return this.http.post(`${this.auth.apiUrl}${this.flashProductGroupUrl}/update`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as FlashProductGroup)
			.catch(error => this.logging.handleError(error));
	}

	getGroupsDropdown(event): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.flashProductGroupUrl}/dropdown`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getDropdown(event): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.flashProductUrl}/dropdown`,JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/flash/flash.service.ts